import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

const namespace = 'positions';

const PositionModel = {
  namespace,
  state: initialState,
  effects: makeListEffects({
    namespace,
    fetchRoute: 'position',
    fetchParams: 'NameDescriptionIsActive',
  }),
  reducers: makeListReducers({
    initialPagination,
    initialState,
  }),
};

export default PositionModel;
